import { makeApiUrl } from '../helpers/makeApiUrl';
import { lStorage, lStorageKeys } from '../helpers/lStorage';
import { authHeader } from '../helpers/authHeader';
import { handleResponse } from '../helpers/handleResponse';
import Cookies  from '../helpers/cookies';
import {LocalGasStation} from "@material-ui/icons";

export let userService = {
    login,
    logout,
    isLoggedIn,
    getInfo,
    getInfoFromUrl,
    update
};


function login(login, password) {
    var data = new FormData();
    data.append('login', login);
    data.append('password', password);
    const requestOptions = {
        method: 'POST',
        body: data
    };

    return fetch(makeApiUrl('access-tokens'), requestOptions)
        .then(handleResponse)
        .then(user => {
            // zapisujemy glowne dane uzytkownika oraz access token
            // wykorzystywany do podtrzymania sesji

            Cookies.set(lStorageKeys.AUTH_USER, JSON.stringify(user.user));
            Cookies.set(lStorageKeys.AUTH_ACCESS_TOKEN, user.accessTokenID);

            // profilaktycznie usuwamy ostatnio przegladane produkty uzytkownika

            lStorage.del(lStorageKeys.LAST_VIEWED_PRODUCTS);

            return user;
        });
}

function getInfoFromUrl() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(makeApiUrl('account'), requestOptions).then(handleResponse)
}

function getInfo() {
    let user = false;
    try {
       const sessionData = JSON.parse(Cookies.get(lStorageKeys.AUTH_USER));
       user = sessionData.user;
    } catch(error) {
    }

    // jesli nie mamy danych użytkownika to zwracamy pusty obiect

    if (!user) {
        return {
            id: null,
            login: null,
            mfgId: null,
            name: null,
            lastName: null,
            settings: []
        }
    }

    return user;
}

function logout() {
    // usuniecie danych zwiazanych z autentykacja w celu
    // wylogowania uzytkownika

    Cookies.remove(lStorageKeys.AUTH_ACCESS_TOKEN);
    Cookies.remove(lStorageKeys.AUTH_USER);

    // usuwamy ostatnio przegladane produkty uzytkownika

    lStorage.del(lStorageKeys.LAST_VIEWED_PRODUCTS);

    lStorage.del(lStorageKeys.RMA_CONFIRMATION);
    lStorage.del(lStorageKeys.RMA_CSV_LOADER);

    // kasujemy wszystkie head menu

    lStorage.delLike(lStorageKeys.HEAD_MENU_PREFIX);


    // tylko dla project-prices
    window.location  = 'https://abonline.pl'
    return

    if (typeof location != 'undefined') {
        location.reload(true);
    }
}

function isLoggedIn() {

    let user = getInfo();
    let token = Cookies.get(lStorageKeys.AUTH_ACCESS_TOKEN);
    return (token && user) ? true : false;
}

function update(user) {
    Cookies.set(lStorageKeys.AUTH_USER, JSON.stringify(user));
}
